// Máscaras de input unificadas (mesmo padrão do sistema-financeiro).
// Digita só números, tratados como centavos -> "1.234,56". Vale para preços e
// para quantidades com 2 casas (ex.: múltiplo da venda mínima 4,04).

// ── Moeda / valor com 2 casas ──────────────────────────────────────────────────
export function maskMoeda(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return '';
  const num = parseInt(digits, 10);
  const reais = Math.floor(num / 100);
  const cents = num % 100;
  return reais.toLocaleString('pt-BR') + ',' + String(cents).padStart(2, '0');
}

// "1.234,56" -> 1234.56 (number). Vazio/inválido -> 0.
export function parseMoeda(v) {
  if (v === '' || v === null || v === undefined) return 0;
  const n = parseFloat(String(v).replace(/\./g, '').replace(',', '.'));
  return Number.isNaN(n) ? 0 : n;
}

// "1.234,56" -> 1234.56 (number) | null quando vazio/inválido (form: "não informado" ≠ 0).
export function parseMoedaOuNull(v) {
  if (v === '' || v === null || v === undefined) return null;
  const n = parseFloat(String(v).replace(/\./g, '').replace(',', '.'));
  return Number.isNaN(n) ? null : n;
}

// Número (decimal do banco) -> string BR "1.234,56" pra preencher input em edição.
export function numeroParaMoeda(n) {
  if (n === null || n === undefined || n === '') return '';
  const x = Number(n);
  if (!Number.isFinite(x)) return '';
  return x.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// ── Inteiro ───────────────────────────────────────────────────────────────────
export function maskInteiro(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}
export function parseInteiro(v) {
  const n = parseInt(String(v ?? '').replace(/\D/g, ''), 10);
  return Number.isNaN(n) ? 0 : n;
}
